import {API} from '../../Services';


async function getCelebrityReferralApi(merchantUid,refId){
    // let token =  localStorage.getItem('token');
    return API.get(`/merchant_admin/${merchantUid}/admin/links/${refId}`);
}

async function createReferralFormLinkApi(obj,refLink){
    let token =  localStorage.getItem('token');
    if(obj.type===1)
        return API.post(`/shop/${obj.merchant}/referrals/by_link`,obj,{headers: { 'Authorization':  `Bearer ${token}`}});
    else
        return API.post(`/shop/${obj.campaign}/referrals/by_link`,obj,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function referralApi(obj,merchantUid){
    let token =  localStorage.getItem('token');
    return API.post(`/shop/${merchantUid}/referrals`,obj,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function getReferralApi(refId,merchantUid){
    // let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantUid}/referrals/${refId}/details`);
}

async function acceptReferralApi(merchantUid,refUid){
    let token =  localStorage.getItem('token');
    return API.post(`/shop/${merchantUid}/referrals/${refUid}/accept`,{
        accepted:true
    },{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function getUser(){
    const token = localStorage.getItem('token')
    return  API.get(`/users/`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {referralApi,getReferralApi,acceptReferralApi,getUser,getCelebrityReferralApi,createReferralFormLinkApi}
